import React, { useEffect, useState } from 'react';
import { doc, setDoc, getDocs, collection, deleteDoc } from 'firebase/firestore';
import { useUser } from '../../UserContext';
import { db } from '../../Firebase';
import { useNavigate } from 'react-router-dom';

function Allcard() {
    const navigate=useNavigate()
    const [withOption, setWithOption] = useState([]);
    const [withoutOption, setWithoutOption] = useState([]);
    const [load, setLoad] = useState(false);
    const { userData, currentUser } = useUser();

    useEffect(() => {
        const fetchCards = async () => {
            setLoad(true);
            try {
                const usersRef = collection(db, 'flashcards');
                const querySnapshot = await getDocs(usersRef);
                const cards = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                cards.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);

                const filteredData = cards.filter(data => data.userId === currentUser?.uid);
                const withOption = filteredData.filter(data => data.answerType === 'multiple');
                const withOutOption = filteredData.filter(data => data.answerType === 'direct');

                setWithOption(withOption);
                setWithoutOption(withOutOption);

            } catch (error) {
                console.error('Error fetching messages:', error);
            } finally {
                setLoad(false);
            }
        };

       
            fetchCards();
        
    }, [currentUser?.uid]);

    const handleDelete = async (cardId) => {
        try {
            await deleteDoc(doc(db, 'flashcards', cardId));
            // Refresh the data after deletion
            const usersRef = collection(db, 'flashcards');
            const querySnapshot = await getDocs(usersRef);
            const cards = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            cards.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);
            const filteredData = cards.filter(data => data.userId === currentUser?.uid);
            const withOption = filteredData.filter(data => data.answerType === 'multiple');
            const withOutOption = filteredData.filter(data => data.answerType === 'direct');

            setWithOption(withOption);
            setWithoutOption(withOutOption);
        } catch (error) {
            console.error('Error deleting card:', error);
        }
    };

    if (load) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-indigo-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600 text-lg">Loading your flashcards...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">Your Flashcard Collection</h1>
                    <p className="text-gray-600 text-lg">Review and manage your learning materials</p>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                    <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-blue-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm font-medium text-gray-600">Direct Answer Cards</p>
                                <p className="text-3xl font-bold text-gray-900">{withoutOption.length}</p>
                            </div>
                            <div className="p-3 bg-blue-100 rounded-full">
                                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-green-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm font-medium text-gray-600">Multiple Choice Cards</p>
                                <p className="text-3xl font-bold text-gray-900">{withOption.length}</p>
                            </div>
                            <div className="p-3 bg-green-100 rounded-full">
                                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Direct Answer Cards */}
                {withoutOption.length > 0 && (
                    <div className="mb-12">
                        <div className="flex items-center mb-6">
                            <div className="w-1 h-8 bg-blue-500 rounded-full mr-4"></div>
                            <h2 className="text-2xl font-bold text-gray-800">Direct Answer Questions</h2>
                            <span className="ml-3 bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full">
                                {withoutOption.length} cards
                            </span>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {withoutOption.map((question) => (
                                <div key={question.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                                    <div className="p-6">
                                        <div className="flex items-start justify-between mb-4">
                                            <div className="flex-1">
                                                <h3 className="font-bold text-gray-800 text-lg mb-3 leading-relaxed">
                                                    {question.question}
                                                </h3>
                                                <div className="bg-green-50 border-l-4 border-green-400 p-3 rounded-r-lg">
                                                    <p className="text-green-800 font-medium">
                                                        <span className="font-bold">Answer:</span> {question.answer}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                                            <span className="text-xs text-gray-500">
                                                Created: {question.createdAt?.toDate?.()?.toLocaleDateString() || 'Recently'}
                                            </span>
                                            <button
                                                onClick={() => handleDelete(question.id)}
                                                className="text-red-500 hover:text-red-700 hover:bg-red-50 p-2 rounded-lg transition-colors duration-200"
                                                title="Delete card"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Multiple Choice Cards */}
               
{withOption.length > 0 && (
    <div className="mb-12">
        <div className="flex items-center mb-6">
            <div className="w-1 h-8 bg-green-500 rounded-full mr-4"></div>
            <h2 className="text-2xl font-bold text-gray-800">Multiple Choice Questions</h2>
            <span className="ml-3 bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
                {withOption.length} cards
            </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {withOption.map((question) => (
                <div key={question.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                    <div className="p-6">
                        <div className="flex items-start justify-between mb-4">
                            <div className="flex-1">
                                <h3 className="font-bold text-gray-800 text-lg mb-4 leading-relaxed">
                                    {question.question}
                                </h3>
                                
                                <div className="space-y-2 mb-4">
                                    {Object.entries(question.options || {}).map(([key, value], index) => (
                                        value && (
                                            <div
                                                key={key}
                                                className={`p-3 rounded-lg border-2 transition-colors duration-200 ${
                                                    key === question.correctOption
                                                        ? 'border-green-400 bg-green-50 text-green-800'
                                                        : 'border-gray-200 bg-gray-50 text-gray-700'
                                                }`}
                                            >
                                                <span className="font-medium mr-2">
                                                    {String.fromCharCode(65 + index)})
                                                </span>
                                                {value}
                                                {key === question.correctOption && (
                                                    <span className="ml-2 text-green-600">
                                                        ✓ Correct
                                                    </span>
                                                )}
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                            <span className="text-xs text-gray-500">
                                Created: {question.createdAt?.toDate?.()?.toLocaleDateString() || 'Recently'}
                            </span>
                            <button
                                onClick={() => handleDelete(question.id)}
                                className="text-red-500 hover:text-red-700 hover:bg-red-50 p-2 rounded-lg transition-colors duration-200"
                                title="Delete card"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
)}

                {/* Empty State */}
                {withoutOption.length === 0 && withOption.length === 0 && !load && (
                    <div className="text-center py-16">
                        <div className="max-w-md mx-auto">
                            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-800 mb-2">No flashcards yet</h3>
                            <p className="text-gray-600 mb-6">Start creating your first flashcard to begin your learning journey!</p>
                            <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
                            onClick={()=>navigate('/create')}>
                                Create Your First Card
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Allcard;